/* eslint-disable react/jsx-no-bind */

// Libraries
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

// Custom Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ViewEditActions from "components/DetailList/ViewEditActions";
import ItineraryInfo from "pages/content/experiences/new-experience/components/ItineraryInfo";
import ItineraryStops from "pages/content/experiences/new-experience/components/IntineraryStops";
import ItiniraryRating from "../itineraryRating";

const ItineraryDetail = ({
  type,
  expId,
  tabValue,
  formField,
  detailPage = true,
  handleEdit,
  setTabValue,
  selectedSlot,
  setDetailPage = () => {},
  selectedCurator = {},
  selectedTickets = [],
  handleSlotChange = () => {},
  handleMediaChange = () => {},
  handleTicketChange = () => {},
  handleCuratorChange = () => {},
}) => {
  const { values, submitForm, resetForm } = useFormikContext();
  const { aiGenerated = false } = values;

  const handleCardTitle = () => {
    switch (type) {
      case "itineraryInfo":
        return "Itinerary Info";
      case "rating":
        return "Rating";
      case "stops":
        return "Stops";
      default:
        return null;
    }
  };
  const handleInfoCard = () => {
    switch (type) {
      case "itineraryInfo":
        return (
          <ItineraryInfo
            editPage
            formField={formField}
            detailPage={detailPage}
            selectedCurator={selectedCurator}
            handleCuratorChange={handleCuratorChange}
          />
        );
      case "rating":
        return <ItiniraryRating formField={formField} />;
      case "stops":
        return (
          <ItineraryStops
            editPage
            id={expId}
            formField={formField}
            tabValue={tabValue}
            setTabValue={setTabValue}
            selectedSlot={selectedSlot}
            selectedTickets={selectedTickets}
            handleSlotChange={handleSlotChange}
            handleMediaChange={handleMediaChange}
            handleTicketChange={handleTicketChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <MDBox>
      <MDBox lineHeight={0} style={{ display: "flex", justifyContent: "space-between" }}>
        <MDTypography variant="h5" fontWeight="bold" textTransform="capitalize" mb={1}>
          {handleCardTitle()}
        </MDTypography>

        <ViewEditActions
          detailPage={detailPage}
          handleEdit={handleEdit}
          noEditIcon={aiGenerated || type === "stops"}
          handleSave={() => submitForm()}
          handleClose={() => {
            resetForm();
            setDetailPage(true);
          }}
        />
      </MDBox>

      <MDBox>{handleInfoCard()}</MDBox>
    </MDBox>
  );
};

ItineraryDetail.propTypes = {
  detailPage: PropTypes.bool,
  setDetailPage: PropTypes.func,
  handleSlotChange: PropTypes.func,
  type: PropTypes.string.isRequired,
  handleMediaChange: PropTypes.func,
  handleTicketChange: PropTypes.func,
  expId: PropTypes.string.isRequired,
  handleCuratorChange: PropTypes.func,
  handleEdit: PropTypes.func.isRequired,
  tabValue: PropTypes.number.isRequired,
  setTabValue: PropTypes.func.isRequired,
  selectedCurator: PropTypes.instanceOf(Object),
  selectedTickets: PropTypes.instanceOf(Object),
  selectedSlot: PropTypes.instanceOf(Object).isRequired,
  formField: PropTypes.instanceOf(Object).isRequired,
};

export default ItineraryDetail;
